import { render } from "./AppointmentPassModuleForm.vue?vue&type=template&id=4a2b7c3c"
import script from "./AppointmentPassModuleForm.vue?vue&type=script&lang=js"
export * from "./AppointmentPassModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__